import { SentimentDissatisfied } from '@mui/icons-material';
import { Button, CircularProgress, Grid } from '@mui/material';
import { Container } from '@mui/system';
import { EntitySelectors } from '@reduxjs/toolkit';
import { BackendResponse, appRegistry, isActionResponse, jsonGet } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState, appStore } from '../store';

export type MainViewBase = {
    children: React.ReactNode,
    path?: string,
    loadingView?: React.ReactNode;
    onError?: (onReload?: () => {}) => React.ReactNode;
};

export type MainViewLoaderProps<T> = MainViewBase & {
    selector: EntitySelectors<T, RootState, ModelId>;
    modelId: ModelId,
    singleModel?: boolean;
    onModelLoaded?: (model: T) => void;
};

export type MainSimpleViewLoaderProps = MainViewBase & {
    children: React.ReactNode;
    onLoaded?: () => void;
};

export const LoadingView = (props: { title?: string; }) => {
    return <Container>
        <Grid container>
            <Grid item xs={6} md={8} lg={12}>
                <h2><CircularProgress /> {props.title ?? 'Chargement en cours...'}</h2>
            </Grid>
        </Grid>
    </Container>;
};
export const NoConnectionView = () => {
    return <Container>
        <Grid container>
            <Grid item xs={6} md={8} lg={12}>
                <h2>Aucune connexion internet <SentimentDissatisfied /></h2>
            </Grid>
        </Grid>
    </Container>;
};
export const OnErrorView = (props: { onReload?: () => void; }) => {
    return <Container>
        <Grid container>
            <Grid item xs={6} md={8} lg={12}>
                <h2>Une erreur est survenue <SentimentDissatisfied /></h2>
                {props.onReload && <Button onClick={props.onReload}>Charger à nouveau</Button>}
            </Grid>
        </Grid>
    </Container>;
};

export const handleServerResult = async (response: BackendResponse) => {
    if (!response) return;
    for (let element of response) {
        if (isActionResponse(element)) appStore.dispatch(element);
        else {
            if (element.attrs.length == 1) {
                const p = appRegistry.get(element.type)?.slice?.actions?.upsertOne(element.attrs[0]);
                if (p) appStore.dispatch(p);
            } else if (element.attrs.length > 1) {
                const p = appRegistry.get(element.type)?.slice?.actions?.upsertMany(element.attrs);
                if (p) appStore.dispatch(p);
            }
        }
    }
};

export const loadMainViewData = async (path: string, options?: RequestInit) => {
    const response = await jsonGet<BackendResponse>(path, options);
    return handleServerResult(response);
};

export const MainViewLoader = <T extends BaseAttrs>(props: MainViewLoaderProps<T>): React.ReactNode => {
    const model = useSelector((state: RootState) => props.selector.selectById(state, props.modelId));

    React.useEffect(() => {
        model && props.onModelLoaded && props.onModelLoaded(model);
    }, [model]);

    return props.children;
};




export const MainSimpleViewLoader = (props: MainSimpleViewLoaderProps) => {
    React.useEffect(() => {
        props.onLoaded && props.onLoaded();
    }, []);

    return props.children;
};
